// src/graphql/campaigns.ts
import { gql } from "@apollo/client";

export const ADMIN_CAMPAIGNS_QUERY = gql`
  query AdminCampaigns {
    campaigns {
      id
      name
      images
      createdAt
      updatedAt
    }
  }
`;

export const GET_CAMPAIGN = gql`
  query GetCampaign($id: ID!) {
    campaign(id: $id) {
      id
      name
      images
    }
  }
`;

export const CAMPAIGNS_PREVIEW_QUERY = gql`
  query CampaignsPreview {
    campaignsPreview {
      id
      name
      images
    }
  }
`;

export const CAMPAIGNS_LISTING_QUERY = gql`
  query CampaignsListing($limitPerCampaign: Int) {
    campaignsListing(limitPerCampaign: $limitPerCampaign) {
      id
      name
      images
    }
  }
`;

export const CREATE_CAMPAIGN_MUTATION = gql`
  mutation CreateCampaign($name: String!, $images: [String!]) {
    createCampaign(input: { name: $name, images: $images }) {
      campaign {
        id
        name
        images
        createdAt
      }
      errors
    }
  }
`;

export const UPDATE_CAMPAIGN_MUTATION = gql`
  mutation UpdateCampaign($id: ID!, $name: String!, $images: [String!]) {
    updateCampaign(input: { id: $id, name: $name, images: $images }) {
      campaign {
        id
        name
        images
        updatedAt
      }
      errors
    }
  }
`;

export const DELETE_CAMPAIGN_MUTATION = gql`
  mutation DeleteCampaign($id: ID!) {
    deleteCampaign(input: { id: $id }) {
      success
      errors
    }
  }
`;
